import { RiRoadMapLine, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { SecondaryNav } from '@/components';
import { usePathSet } from '@/hooks/usePathSet';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { SignedInPageLayoutContentContainer } from '@/layout/signed-in-page/components';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';
import { useProjectId } from '@/pages/shared/hooks/useProjectId';
import { buildPath } from '@/utils/buildPath';

import { DegradationDriversCard } from '../../components/DegradationDriversCard';
import { EcologicalIntegrityCard } from './components/EcologicalIntegrityCard';
import { FloraAndFaunaCard } from './components/FloraAndFaunaCard';

export const EcologicalIntegrityPage = () => {
  const { t } = useTranslation();

  const { pathname } = useLocation();

  const menuItems = useMenuItems();
  const projectId = useProjectId();
  const pathSet = usePathSet();

  return (
    <SignedInPageLayout items={menuItems} withCustomContentContainer>
      <SecondaryNav
        title={t('shared.ncaDetail.ecologicalIntegrity.pageTitle')}
        backPath={buildPath(pathSet.projectDetails, { pathParams: { projectId } })}
        action={{
          to: buildPath(pathSet.interactiveMap, { pathParams: { projectId } }),
          state: { from: pathname },
          variant: 'contained',
          children: t('shared.ncaDetail.buttons.seeInteractiveMap'),
          leftAdornment: <RiRoadMapLine size={20} />,
        }}
      />

      <SignedInPageLayoutContentContainer>
        <Stack spacing={10}>
          <Stack spacing={8}>
            <span className='typography-overline'>
              {t('shared.ncaDetail.ecologicalIntegrity.historicalData.heading')}
            </span>
            <EcologicalIntegrityCard />
          </Stack>
          <Stack spacing={8}>
            <span className='typography-overline'>{t('shared.ncaDetail.ecologicalIntegrity.breakdown.heading')}</span>
            <DegradationDriversCard />
            <FloraAndFaunaCard />
          </Stack>
        </Stack>
      </SignedInPageLayoutContentContainer>
    </SignedInPageLayout>
  );
};
